<template>
  <div v-if="bulletPoints.length" class="product-bulletpoints">
    <ul class="bulletpoints">
      <li v-for="(row, index) in bulletPoints" :key="index">
        <span v-if="row.content" v-html="generate(row.content)" />
      </li>
    </ul>
  </div>
</template>
<script>
import bbcodeHTML from 'marketplace-front-core/config/bbcodeHTML'
export default {
  props: {
    bulletPoints: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    generate (content) {
      return bbcodeHTML(content, 'minimal', true)
    }
  }
}
</script>
